import React from "react";

const Pricing = () => {
	return (
		<section className="module">
			<div className="container">
				<div className="row">
					<div className="col-sm-2 col-sm-offset-5">
						<div className="alt-module-subtitle">
							<span className="holder-w"></span>
							<h5 className="font-serif">Rabarbaro’s Lunch</h5>
							<span className="holder-w"></span>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-sm-8 col-sm-offset-2">
						<h3 className="module-title font-alt">Mar–Ven 12:00–14:15</h3>
						<p className="align-center">
							Cambiamo sempre tutti i giorni, e diciamo a voce. Daj.
							<br />
							Menù diverso ogni giorno in base a mercato, stagioni, reperibilità e
							gusti variopinti.
						</p>
						<br />
					</div>
				</div>

				<div className="row">
					<div className="col-sm-6 col-md-4 col-lg-4">
						<div className="price-table font-alt">
							<h4>ADAGIO</h4>
							<div className="borderline"></div>
							<p className="price">
								<span>€</span>38
							</p>
							<ul className="price-details">
								<li style={{ fontWeight: "normal" }}>
									Con sfizio, primo e secondo piatto.
								</li>
								<li style={{ fontWeight: "normal" }}>
									Include acqua, entrée, selezione di vino, lievitati, piccola
									macedonia, chiusura dolce ed espresso Premium Musetti.
								</li>
							</ul>
						</div>
					</div>

					<div className="col-sm-6 col-md-4 col-lg-4">
						<div className="price-table font-alt best">
							<h4>FORTE</h4>
							<p className="small">Menu a voce</p>
							<div className="borderline"></div>
							<p className="price">
								<span>€</span>15/25
							</p>
							<ul className="price-details">
								<li style={{ fontWeight: "normal" }}>€15 con primo piatto</li>
								<li style={{ fontWeight: "normal" }}>€17 con secondo piatto</li>
								<li style={{ fontWeight: "normal" }}>
									€25 con primo e secondo piatto
								</li>
								<li style={{ fontWeight: "normal" }}>
									Include acqua, entrée, selezione di vino, lievitati, piccola
									macedonia, chiusura dolce ed espresso Premium Musetti.
								</li>
							</ul>
						</div>
					</div>

					<div className="col-sm-6 col-md-4 col-lg-4">
						<div className="price-table font-alt">
							<h4>SFIZI</h4>
							<div className="borderline"></div>
							<p className="price">
								<span>€</span>5/22
							</p>
							<ul className="price-details">
								<li style={{ fontWeight: "normal" }}>
									€15 Salumi da osteria, giardiniera e tigelle
								</li>
								<li style={{ fontWeight: "normal" }}>
									€16 Formaggi da dispensa e composte
								</li>
								<li style={{ fontWeight: "normal" }}>
									€15 Crostone di hummus, formaggi vegan e vegetali
								</li>
								<li style={{ fontWeight: "normal" }}>
									€20 Fiocco di culatello e burro di acciughe
								</li>
								<li style={{ fontWeight: "normal" }}>
									€18/22 Tartare del giorno di pesce o carne con oli aromatici,
									croccante e vegetali
								</li>
								<li style={{ fontWeight: "normal" }}>
									€5 Verdure rosticciate del dì
								</li>
								<li style={{ fontWeight: "normal" }}>€5 Dolce della carta</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Pricing;